import { 
  Heart, Gavel, Globe, Utensils, Home, Calculator, Building, 
  Shield, FileText, CreditCard, Newspaper, UsersRound, IdCard, Flame,
  FileCheck, PenTool, Wallet, Scale, Landmark, Handshake,
  FileSignature, Stamp, ScrollText, Receipt, Zap, FileBarChart,
  Factory, Briefcase, Coins, FileSpreadsheet, Lightbulb, Power
} from 'lucide-react';

// Government Certificate Services (Category 1)
export const category1Documents = [
  {
    id: 1,
    name: "Marriage Certificate",
    icon: Heart
  },
  {
    id: 2,
    name: "Court Marriage",
    icon: Gavel
  },
  {
    id: 3,
    name: "Passport",
    icon: Globe
  },
  {
    id: 4,
    name: "E-Food License (FSSAI)",
    icon: Utensils  // Better: Utensils for food license
  },
  {
    id: 5,
    name: "Domicile Certificate",
    icon: Home
  },
  {
    id: 6,
    name: "E-Income Certificate",
    icon: Coins  // Better: Coins for income
  },
  {
    id: 7,
    name: "Udyam Registration & E-Gumasta License",
    icon: Factory  // Better: Factory for business registration
  },
  {
    id: 8,
    name: "Police Clearance Certificate (PCC)",
    icon: Shield
  },
  {
    id: 9,
    name: "IT Return File",
    icon: FileSpreadsheet  // Better: FileSpreadsheet for IT returns
  },
  {
    id: 10,
    name: "GST Registration",
    icon: CreditCard
  },
  {
    id: 11,
    name: "Gazette Notification",
    icon: ScrollText  // Better: ScrollText for official gazette
  },
  {
    id: 12,
    name: "NGO Darpan Registration",
    icon: UsersRound
  }
];

// Name Change & Registration Services (Category 2)
export const category2Documents = [
  {
    id: 1,
    name: "E-Aadhaar & Data Correction",
    icon: IdCard
  },
  {
    id: 2,
    name: "Electricity Bill Name Change",
    icon: Zap  // Better: Zap for electricity
  },
  {
    id: 3,
    name: "Property Tax Bill Name Change",
    icon: Landmark
  },
  {
    id: 4,
    name: "Mahanagar Gas Bill Name Change",
    icon: Flame
  },
  {
    id: 5,
    name: "Leave and License Registration",
    icon: FileSignature
  },
  {
    id: 6,
    name: "Newspaper Notification",
    icon: Newspaper
  },
  {
    id: 7,
    name: "Affidavit and Notary",
    icon: Stamp
  },
  {
    id: 8,
    name: "Aadhaar Smart Card",
    icon: IdCard
  },
  {
    id: 9,
    name: "PAN Card",
    icon: FileBarChart  // Better: FileBarChart for PAN card (tax related)
  },
  {
    id: 10,
    name: "Ration Card",
    icon: Wallet
  }
];

// Litigation Services
export const litigationServices = [
  {
    id: 1,
    name: "Criminal Law"
  },
  {
    id: 2,
    name: "Civil Law"
  },
  {
    id: 3,
    name: "Family Law"
  },
  {
    id: 4,
    name: "Arbitration"
  },
  {
    id: 5,
    name: "Mediation"
  },
  {
    id: 6,
    name: "Legal Notice"
  },
  {
    id: 7,
    name: "Society Law"
  },
  {
    id: 8,
    name: "138 Negotiable Instrument Act"
  },
  {
    id: 9,
    name: "Trade Mark Registration"
  },
  {
    id: 10,
    name: "Labour and Employment Law"
  },
  {
    id: 11,
    name: "Income Tax and GST"
  },
  {
    id: 12,
    name: "Adoption and Legal Guardianship"
  },
  {
    id: 13,
    name: "Divorce Case"
  },
  {
    id: 14,
    name: "Partnership Deed"
  }
];

// Non-Litigation Services
export const nonLitigationServices = [
  {
    id: 1,
    name: "Agreement for Sale"
  },
  {
    id: 2,
    name: "Sale Deed"
  },
  {
    id: 3,
    name: "Release Deed"
  },
  {
    id: 4,
    name: "Gift Deed"
  },
  {
    id: 5,
    name: "Power of Attorney"
  },
  {
    id: 6,
    name: "Memorandum of Understanding"
  },
  {
    id: 7,
    name: "Leave and License Agreement"
  },
  {
    id: 8,
    name: "Will Registration"
  },
  {
    id: 9,
    name: "Legal Paper Notice"
  },
  {
    id: 10,
    name: "Notary, Attestation, True Copy"
  },
  {
    id: 11,
    name: "Cheque Bounce"
  },
  {
    id: 12,
    name: "RERA Court"
  },
  {
    id: 13,
    name: "Court Marriage"
  }
];